import { assert_number_gt_0, assert_number_gte_0, assert_string_not_empty, assert_type_enum } from '@shared/asserts/utils_asserts';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { EWorkspaceCreditTransactonType } from '../workspace_credit_transaction/EWorkspaceCreditTransactonType';

//todo: split to payment transaction and stripe transaction
export class DTOworkspacePaymentTransactionStripe extends DTO__database_entity {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.WORKSPACE_PAYMENT_TRANSACTION_STRIPE;

  //STATIC METHODS

  /*
   * DB FIELDS
   */
  workspace_id!: string;
  user_id_creator!: string;

  stripe_session_id!: string;
  stripe_status!: string;

  status!: string;

  amount_total!: number;
  currency!: string;
  credits_amount!: number;

  balance_before!: number;
  balance_after!: number;

  /*
   * METHODS
   */

  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_string_not_empty(this.workspace_id);
    assert_string_not_empty(this.user_id_creator);
    assert_string_not_empty(this.stripe_session_id);
    assert_string_not_empty(this.stripe_status);

    assert_type_enum(this.status, EWorkspaceCreditTransactonType);

    assert_number_gt_0(this.amount_total);
    assert_string_not_empty(this.currency);
    assert_number_gt_0(this.credits_amount);

    assert_number_gte_0(this.balance_before);
    assert_number_gte_0(this.balance_after);
  }
}
